import script from "./audit.vue?vue&type=script&setup=true&lang=js"
export * from "./audit.vue?vue&type=script&setup=true&lang=js"

import "./audit.vue?vue&type=style&index=0&id=96be3162&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96be3162"]])

export default __exports__